module.exports = __webpack_public_path__ + "img/m-banner-aoacwpci-ja-JP.12d598ab.png";